/**
 * 权限指令
 * @description 权限指令，用于判断用户权限，如果用户没有权限，则隐藏元素
 * @param { Array<string>} permissions - 权限集合
 * @param { string } binding.value - 指令绑定的权限字符
 */
import type { DirectiveBinding } from 'vue'
import type { Ref } from 'vue'
import usePermission from '@/hooks/usePermission'
// 定义指令绑定类型
type PermissionBinding = DirectiveBinding<string>

// 缓存权限列表，避免每次调用都创建新的 hook 实例
let cachedPermissionList: Ref<Array<string>> | null = null

// 获取权限列表，带缓存
const getPermissionList = () => {
    if (!cachedPermissionList) {
        const { buttonPermissionList } = usePermission()
        cachedPermissionList = buttonPermissionList
    }
    return cachedPermissionList
}

/**
 *
 * @description 权限指令
 * @param { string } binding.value - 指令绑定的权限字符
 */
export const permission = () => {
    return {
        mounted(el: HTMLElement, binding: PermissionBinding) {
            const buttonPermissionList = getPermissionList()
            const { value } = binding
            if (value) {
                // 判断是否有权限
                const permissionFlag = value
                const hasPermissions = buttonPermissionList.value.includes(permissionFlag)
                // 如果没有权限，则移除元素
                if (!hasPermissions) {
                    if (el.parentNode) {
                        el.parentNode.removeChild(el)
                    }
                }
            } else {
                return false
            }
        }
    }
}

/**
 * @description 检测权限
 * @param { Array<string>} permissions - 权限集合
 * @param { string } permission - 权限字符
 */
export const hasPermission = (permission: string) => {
    const buttonPermissionList = getPermissionList()
    // 处理 permissions 为 null 或 undefined 的情况
    if (!buttonPermissionList.value) {
        return false
    }
    return buttonPermissionList.value.includes(permission)
}
